import { Capacitor } from '@capacitor/core';
import { PushNotifications, type Token } from '@capacitor/push-notifications';
import { getSupabase } from '../supabase.js';

const REGISTERED_TOKEN_KEY = 'niveo:push_token';

function platform(): 'ios' | 'android' | 'web' {
  const p = Capacitor.getPlatform();
  if (p === 'ios') return 'ios';
  if (p === 'android') return 'android';
  return 'web';
}

async function callRegister(token: string): Promise<void> {
  if (typeof localStorage !== 'undefined' && localStorage.getItem(REGISTERED_TOKEN_KEY) === token) {
    return;
  }
  const sb = getSupabase();
  const { error } = await sb.functions.invoke('register-device', {
    body: { token, platform: platform(), app_version: '0.1.0' },
  });
  if (error) {
    console.warn('[push] register failed', error.message);
    return;
  }
  try {
    localStorage?.setItem(REGISTERED_TOKEN_KEY, token);
  } catch {
    // ignore
  }
}

export async function initPushNotifications(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;
  // Push remote (FCM/APNs) richiede google-services.json (Android) o entitlements
  // APS (iOS). L'APK debug Niveo attuale NON include questi → chiamare
  // PushNotifications.register() lancia un'eccezione nativa che esce dal
  // try/catch JS e crasha l'app. Disabilitato finché non integreremo Firebase.
  // Le notifiche LOCALI (LocalNotifications) restano attive, non passano da qui.
  console.info('[push] remote push registration skipped (FCM not configured)');
}

export async function unregisterPushToken(): Promise<void> {
  if (typeof localStorage === 'undefined') return;
  const token = localStorage.getItem(REGISTERED_TOKEN_KEY);
  if (!token) return;
  try {
    await getSupabase().functions.invoke('register-device', {
      body: { token, platform: platform(), unregister: true },
    });
  } catch {
    // ignore
  }
  localStorage.removeItem(REGISTERED_TOKEN_KEY);
}
